<template>
  <div class="export-central row">
    <div class="col-md-6 mt-2">
      <h1>Zip Export Centre</h1>
      <organization-switcher
          :show-teams="false"
          :load-teams-but-dont-show="true"
          class="mt-2 mb-2"
          @setOrganization="setOrganization"
      />
    </div>
    <!--<div class="col-6">
      <div class="d-inline-block bg-black p-1 mb-1 border-radius clickable" @click="showForm = true">
        Add new
        <icon type="plus"/>
      </div>
      <div v-if="showForm" class="p-2 form mb-2">
        Target location:<br>
        <drop-down
            :labels="['vHUB', 'ZIP for download', 'external']"
            :values="['vhub', 'zip', 'external']"
            class="dark"
            @select="setMode"
        />
        <div v-if="mode === 'vhub'">
          Select a target location:<br>
          <input class="form-text form-text-dark ml-0" placeholder="Search for webapp is search and dropdown"
                 type="text">
        </div>
        Select one or multiple projects:<br>
        <input class="form-text form-text-dark ml-0" placeholder="Search for project is search and dropdown"
               type="text">
        <div class="settings-button d-inline-block switched-colors" @click="showForm = false; mode = null;">Abort</div>
        <div class="settings-button d-inline-block switched-colors">Export</div>
      </div>
      <input class="form-text form-text-dark ml-0" placeholder="Search for project" type="text">
    </div>
    <div class="col-12 mb-3"/>
    <div v-if="false" class="col">
      <h2>On vHUB</h2>
      <webapp-export-list
        v-if="organizationId"
        :organization-id="organizationId"
        />
    </div>-->
    <div class="col col-md-12 ml-3">
      <zip-export-list
          v-if="organizationId && !message"
          :organization-id="organizationId"
      />
      <div v-else-if="message" class="form-error row">
        {{ message }}
      </div>
    </div>

    <!--<div v-if="false" class="col">
      <h2>On external location</h2>
      <webapp-export :is-external="true" :webapp-is-outdated="true" :webapp="{name: 'LMS Export'}"/>
      <webapp-export :is-external="true" :webapp="{name: 'DB'}"/>
      <webapp-export :is-external="true" :webapp="{name: 'SNCF'}"/>
    </div>-->
  </div>
</template>

<script>
import ZipExportList from "@/components/exporter/ZipExportList.vue";
import OrganizationSwitcher from "@/components/organizations/OrganizationSwitcher.vue";
export default {
  name: "ExporterCentral",
  components: {ZipExportList, OrganizationSwitcher},
  data() {
    return {
      showForm: false,
      mode: null,
      organizationId: null,
      message: ''
    }
  },
  methods: {
    setMode(mode) {
      this.mode = mode;
    },
    async setOrganization(organizationId) {
      this.organizationId = organizationId;
      await this.checkServiceEnabled();
      if(!this.message) {
          await this.loadPrivateTeamOfUser();
      }
    },
    async loadPrivateTeamOfUser() {
      const teams = await this.$store.dispatch('getUserTeamsWithRoles', ['admin', 'editor']);
      if(teams && teams.length > 0){
        console.log(teams);
        const privateTeam = teams.find(item => {
          return item.visibility === 0 && item.organizationId === this.organizationId;
        });
        if(privateTeam){
          return true;
        }
        console.log('found private team', privateTeam);
      }
      this.message = 'You do not seem to have writing access to your private team on this organization. This is necessary to create exports';
    },
    async checkServiceEnabled() {
      this.message = '';
      console.log('checking service...')
      const isEnabled = await this.$store.dispatch('checkIfService', {
        organizationIds: [this.organizationId],
        serviceName: 'zipExporter'
      });
      console.log(isEnabled, 'isEnabled');
      if(!isEnabled) {
        this.message = 'Your organization has not enabled this feature. Please contact Side Effects or your administrator'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.export-item {
  padding: 15px;
  margin-bottom: 15px;
  background-color: var(--vform-editor-ui-quinary-color);
}

.bg-black {
  background-color: #000;
}

.form {
  background-color: var(--vform-editor-ui-secondary-color);
}
</style>